import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { Button } from '@mui/material';

import SignInIcon from './assets/sign-in.svg';
import useStyles from './styles';

interface Props {
    className?: string;
}

const SignInButton: React.FC<Props> = ({ className }) => {
    const { classes, cx } = useStyles();
    const history = useHistory();
    const goToLogin = useCallback(() => history.push('/login'), [history]);

    return (
        <Button
            fullWidth
            disableElevation
            disableRipple
            disableFocusRipple
            variant="contained"
            endIcon={<SignInIcon />}
            onClick={goToLogin}
            className={cx(classes.root, className)}
        >
            {'Sign in'}
        </Button>
    );
};

export default SignInButton;
